export default __webpack_public_path__ + "static/color-picker-agnostic-color-dont-6b746b007bbba79eec56006abd62ef677f72d36a4d1ad780dc1d9adc5d7fe291.png";